<!-- 
	User
	role: User
  	User main page to display lottery information or verify email 
-->

<template>
  <div class="user text-white">
    <div v-if="user.additionalData !== null && user.apiData !== null">
      <div
        v-if="
          user.apiData.Profile !== null &&
            user.apiData.Profile.FirstName !== null
        "
      >
        <div class="flex flex-col mx-auto lg:flex-row gap-8">
          <div class="flex flex-col gap-4 lg:w-1/8">
            <template v-if="activeBadge == true">
              <Badge
                :user="user"
                class=""
              />
            </template>
            <div class="contactInformation p-6 text-left">
              <p class="text-xl font-medium py-2">
                CONTACT INFORMATION
              </p>
              <p class="text-left">
                {{ formatPhone(user.apiData.Profile.HomePhone) }}<br>
                {{ user.apiData.Profile.AddressLineOne }}<br>
                {{ user.apiData.Profile.City }}, {{ user.apiData.Profile.Province }} {{ user.apiData.Profile.PostalCode }}<br>
              </p>
              <div
                class="py-3"
                text-center
              >
                <a href="/settings/update-profile">
                  <button
                    class="rounded-lg my-4 py-2 px-4 bg-gray-500 text-gray-100 hover:bg-gray-800 duration-300 text-base"
                  >
                    UPDATE CONTACT INFO
                  </button>
                </a>
              </div>	
              <div class="">
                <p>Registration Date: </p>
                <p>{{ dateTime(user.apiData.Profile.OptInDate) }}</p>
              </div>
              <div class="my-4">
                <p>Proceeds Benefitting: </p>
                <p>
                  {{
					user.apiData.Profile.NewDesignation ||
					user.apiData.Profile.CurrentDesignation
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="sm:w-100 lg:w-3/4 grow">
            <News :user="user" />
			
            <DeductionSchedule id="DeductionScheduleSection"
              :user="user"
              :pay-periods="payperiods"
              style="height: 500px; overflow: auto; margin-top:36px;background-color:#fff"
            />
			
          </div>
          <div class="flex flex-col gap-8 grow-0 lg:w-1/8">
            <!-- Column -->
            <CurrentTicketPackages />
            <UpdateTicketPackagesLinkCard v-if="isCurrentlyEnrolled()" />
            <UpcomingDeduction :next-pay-period="nextPayPeriod" />
          </div>
        </div>
      </div>
      <div v-else>
        <EmailVerificationComponent :user="user" />
      </div>
    </div>
    <div v-else>
      <Loading />
    </div>
  </div>
</template>

<script>
	import moment from "moment";

	import { computed } from "vue";
	import { mapGetters, useStore } from "vuex";

	import { getUserProfile } from "@/utils/api";
	import store from "../store";

	import Greeting from "@/components/Greeting";
	import UserInfo from "@/components/UserInfo";
	import News from "@/components/News";
	import EmailVerificationComponent from "@/components/EmailVerificationComponent";
	import Loading from "@/components/Loading";
	import Badge from "@/components/Badge";
	import BadgeFifty from "@/components/BadgeFifty";
	import CustomButton from '@/components/CustomButton'
	import { WINWINMAINPACKAGES, WINWIN5050PACKAGES, nextDrawDate}  from '@/utils/constants'
	import { getUserPayPeriod } from "@/utils/api";
	import CurrentTicketPackages from '@/components/CurrentTicketPackages'
import DeductionSchedule from "../components/DeductionSchedule";
import UpcomingDeduction from "../components/UpcomingDeduction";
import UpdateTicketPackagesLinkCard from "../components/UpdateTicketPackagesLinkCard";


	export default {
		name: "User",
		components: {
    CustomButton,
    Greeting,
    UserInfo,
    News,
    EmailVerificationComponent,
    Loading,
    Badge,
    BadgeFifty,
    CurrentTicketPackages,
    DeductionSchedule,
    UpcomingDeduction,
    UpdateTicketPackagesLinkCard
},
		data() {
			return {
				activeBadge: true,
				payperiods: null,
				nextPayPeriod: null,
				previousDeduction: null,
			};
		},
		computed: {
			...mapGetters({
				user: "user",
			}),
			nextDrawDate: function() {
				return nextDrawDate(new Date())
			}
		},
		setup() {
			const store = useStore();

			return {
				user: computed(() => store.state.user),
			};
		},
		async mounted() {
			try {
				// attempt to call userProfile from API
				const token = this.user.token;

				const res = await getUserProfile(token);
				if (res.Success) {
					// if successful set to store
					store.dispatch("setApiData", res.Data);
					console.log(res.Data)
					await this.loadUserPayPeriods(token, this.user.apiData.UserId)
				} else {
					// if failure call modal error
					store.dispatch(
						"setError",
						"There was an error fetching your profile"
					);
				}

			} catch (err) {
				console.log(err);
			}
		},
		methods: {
			loadUserPayPeriods: async function(token, userId) {
				const that = this;
				const payPeriodRes = await getUserPayPeriod(token, userId);
				if (payPeriodRes.Success) {
					that.payperiods = payPeriodRes.Data
					that.processPayPeriods()
				}
			},
			dateTime(value) {
				// format Date object to readible format
				return moment(value).format("MMMM Do, YYYY");
			},
			nextBadge: function() {
				this.activeBadge = !this.activeBadge;
			},
			formatPhone: function(str) {
				//Filter only numbers from the input
				let cleaned = ('' + str).replace(/\D/g, '');

				//Check if the input is of correct length
				let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

				if (match) {
					return match[1] + '-' + match[2] + '-' + match[3]
				};

				return null

			},
			getMainTicketPackageByValue(val) {
				
				var ticketPackage = WINWINMAINPACKAGES.find(x=>x.Cost == val)
				if (ticketPackage) return ticketPackage.PackageName

				return ''
				
			},
			get5050TicketPackageByValue(val) {
				
					var ticketPackage = WINWIN5050PACKAGES.find(x=>x.Cost == val)
					if (ticketPackage) return ticketPackage.PackageName

					return ''
				
			},

			processPayPeriods() {
				const that = this
				var payperiods = this.payperiods;

				const today = new Date();

				const historicalPayPeriods = payperiods.filter(x=>new Date(x.PayPeriodDate) < today && x.OptedIn)
				const upcomingPayPeriods = payperiods.filter(x=>new Date(x.PayPeriodDate) > today);
				if (upcomingPayPeriods.length > 0) {
					that.nextPayPeriod = upcomingPayPeriods[0]
				}

				if (historicalPayPeriods.length > 0) {
					that.previousDeduction = historicalPayPeriods[historicalPayPeriods.length - 1]
				}


			},
			isCurrentlyEnrolled: function() {
							return this.user?.apiData?.Profile?.Year2022 && !this.user?.apiData?.Profile?.Year2022OptOut
			}
		},
	};
</script>
<style scoped>
	.next-badge {
		margin: 0;
		padding: 7.5px;
		background-color: rgba(192, 192, 192, 0.3);
		color: white;
		cursor: pointer;
	}


</style>
